import * as React from "react";
import {
  MdDashboard,
  MdPeople,
  MdInsertDriveFile,
  MdAttachMoney,
  MdContentCopy
} from "react-icons/md";

/** Custom types */
import { NavItemType } from "../CustomTypes";

export const RootsAdmin: Array<NavItemType> = [
  {
    to: "/dashboard",
    role: "ROOTS_ADMIN",
    title: "Dashboard",
    icon: <MdDashboard size="1.3em" />
  },
  {
    to: "#",
    role: "ROOTS_ADMIN",
    title: "Manage",
    icon: <MdPeople size="1.3em" />,
    subMenu: [
      {
        to: "/team",
        title: "Users"
      },
      {
        to: "/admin/companies",
        title: "Companies"
      }
    ]
  },
  {
    to: "/admin-reports",
    role: "ROOTS_ADMIN",
    title: "Reports Management",
    icon: <MdInsertDriveFile size="1.3em" />
  },
  {
    to: "/admin/sales",
    role: "ROOTS_ADMIN",
    title: "Sales",
    icon: <MdAttachMoney size="1.3em" />
  },
  {
    to: "/category-management",
    role: "ROOTS_ADMIN",
    title: "Category Management",
    icon: <MdContentCopy size="1.3em" />
  },
  {
    to: "/interest-management",
    role: "ROOTS_ADMIN",
    title: "Interest Management",
    icon: <MdContentCopy size="1.3em" />
  },
  {
    to: "/tags-management",
    role: "ROOTS_ADMIN",
    title: "Tags Management",
    icon: <MdContentCopy size="1.3em" />
  }
];



// WEBPACK FOOTER //
// ./src/Navigation/RootsAdminRoutes.tsx